/* Just Silver - policy pages (quiet luxury, v2).
   Shapes the Word-pasted page text into an interactive page and runs the
   motion. Everything is an enhancement: without this file the page shows
   the full text, the facts, the journey and the help band as they are.

   Structure rules
     - a paragraph that is entirely bold (and short) is a heading
     - a heading directly followed by another heading starts a new group;
       its text (after any "→") names the group
     - a heading that repeats the page title is dropped
     - the first short paragraph moves up into the hero as the subtitle
   The page's text is never changed. */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var root = d.querySelector('[data-jsq-policy]');
  if (!root) return;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };
  var reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(w.Shopify && w.Shopify.designMode);
  var anim = !reduce && !design && ('IntersectionObserver' in w);

  var prose = $('[data-jsq-prose]');
  var KEEP = ['Just Silver', 'Indian Rupees', 'India', 'Indian', 'INR', 'VAT', 'GST', 'COD', 'UPI', 'BIS', 'IST', 'OTP'];
  var clean = function (s) { return (s || '').replace(/\s+/g, ' ').trim(); };
  var bare = function (s) { return clean(s).replace(/[\s.:]+$/, ''); };

  var sentence = function (s) {
    s = bare(s);
    var letters = s.replace(/[^A-Za-z]/g, '');
    if (!letters) return s;
    var caps = letters.replace(/[^A-Z]/g, '').length / letters.length;
    var words = s.split(' ').filter(function (x) { return x.replace(/[^A-Za-z]/g, '').length > 2; });
    var titled = words.filter(function (x) { return /^[^a-z]*[A-Z]/.test(x); }).length / Math.max(1, words.length);
    if (caps < 0.6 && titled < 0.75) return s;
    var out = s.toLowerCase();
    out = out.charAt(0).toUpperCase() + out.slice(1);
    KEEP.forEach(function (k) { out = out.replace(new RegExp('\\b' + k + '\\b', 'gi'), k); });
    return out;
  };

  var topBold = function (el) {
    return $$('b, strong', el).filter(function (b) {
      var p = b.parentElement;
      while (p && p !== el) { if (/^(B|STRONG)$/.test(p.tagName)) return false; p = p.parentElement; }
      return true;
    }).map(function (b) { return b.textContent; }).join(' ');
  };
  var isEmpty = function (el) { return !clean(el.textContent) && !el.querySelector('img, iframe, video, svg, table'); };
  var isHeading = function (el) {
    if (/^H[1-6]$/.test(el.tagName)) return !!clean(el.textContent);
    if (el.tagName !== 'P' || el.querySelector('a, img')) return false;
    var txt = bare(el.textContent);
    if (!txt || txt.length > 90) return false;
    return bare(topBold(el)) === txt;
  };
  var used = {};
  var slug = function (s) {
    var base = s.toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    var id = base;
    var n = 2;
    while (used[id] || d.getElementById(id)) { id = base + '-' + n; n += 1; }
    used[id] = true;
    return id;
  };
  var el = function (tag, cls, text) {
    var e = d.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  };

  /* ================= 1. shape the text ================= */
  var groups = [];
  var shared = [];
  var items = [];
  if (prose) {
    $$('[style]', prose).forEach(function (x) {
      ['font-family', 'font-size', 'line-height', 'color', 'margin-top', 'margin-bottom'].forEach(function (p) { x.style.removeProperty(p); });
      if (!clean(x.getAttribute('style'))) x.removeAttribute('style');
    });
    $$('.MsoNormal', prose).forEach(function (x) { x.classList.remove('MsoNormal'); if (!x.className) x.removeAttribute('class'); });

    var kids = Array.prototype.slice.call(prose.children).filter(function (x) {
      if (isEmpty(x)) { x.remove(); return false; }
      return true;
    }).map(function (x) { return { el: x, head: isHeading(x) }; });

    var pageTitle = bare(root.getAttribute('data-title')).toLowerCase();
    kids = kids.filter(function (k) {
      if (k.head && bare(k.el.textContent).toLowerCase() === pageTitle) { k.el.remove(); return false; }
      return true;
    });

    // the first short paragraph becomes the hero subtitle
    var sub = $('[data-jsq-sub]');
    if (sub && kids.length && !kids[0].head && kids[0].el.tagName === 'P' && clean(kids[0].el.textContent).length <= 180) {
      sub.textContent = clean(kids[0].el.textContent);
      sub.hidden = false;
      kids[0].el.remove();
      kids.shift();
    }

    var group = { label: root.getAttribute('data-group') || 'Overview', lead: [], items: [] };
    groups.push(group);
    var cur = null;
    kids.forEach(function (k, i) {
      if (!k.head) {
        if (cur) cur.nodes.push(k.el); else group.lead.push(k.el);
        return;
      }
      var text = bare(k.el.textContent);
      var next = kids[i + 1];
      k.el.remove();
      if (next && next.head) {
        group = { label: sentence(text.split(/→|->/).pop()), lead: [], items: [] };
        groups.push(group);
        cur = null;
        return;
      }
      cur = { label: sentence(text), nodes: [], group: group };
      group.items.push(cur);
      items.push(cur);
    });
    groups = groups.filter(function (g) { return g.lead.length || g.items.length; });

    // a part named like the "shared" label applies to every group: it is shown
    // under the switch whichever group is selected
    var sharedName = clean(root.getAttribute('data-shared')).toLowerCase();
    shared = groups.filter(function (g) { return sharedName && g.label.toLowerCase() === sharedName; });
    groups = groups.filter(function (g) { return shared.indexOf(g) === -1; });

    var fill = function (g, into) {
      if (g.lead.length) {
        var lead = el('div', 'jsq-pol__lead');
        lead.setAttribute('data-jsq-pop', '');
        g.lead.forEach(function (n) { lead.appendChild(n); });
        // a closing paragraph after a list reads as a note
        var last = lead.lastElementChild;
        if (last && last.tagName === 'P' && last.previousElementSibling && /^(UL|OL)$/.test(last.previousElementSibling.tagName)) last.classList.add('jsq-pol__note');
        into.appendChild(lead);
      }
      if (!g.items.length) return;
      var acc = el('div', 'jsq-pol__acc');
      g.items.forEach(function (it, n) {
        var num = (n < 9 ? '0' : '') + (n + 1);
        var sec = el('section', 'jsq-pol__item');
        sec.id = slug(it.label);
        sec.setAttribute('data-jsq-pop', '');
        sec.style.setProperty('--i', Math.min(n, 6));
        var h = el('h3', 'jsq-pol__q');
        var btn = el('button', 'jsq-pol__qbtn');
        btn.type = 'button';
        btn.id = sec.id + '-q';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', sec.id + '-a');
        btn.appendChild(el('span', 'jsq-pol__num', num));
        btn.appendChild(el('span', 'jsq-pol__qt', it.label));
        var icon = el('span', 'jsq-pol__icon');
        icon.setAttribute('aria-hidden', 'true');
        btn.appendChild(icon);
        h.appendChild(btn);
        var a = el('div', 'jsq-pol__a');
        a.id = sec.id + '-a';
        a.setAttribute('role', 'region');
        a.setAttribute('aria-labelledby', btn.id);
        var inner = el('div', 'jsq-pol__a-in');
        var body = el('div', 'jsq-pol__a-body');
        it.nodes.forEach(function (x) { body.appendChild(x); });
        var copy = el('button', 'jsq-pol__copy');
        copy.type = 'button';
        copy.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3.2-3.2a4.5 4.5 0 0 0-6.4-6.4l-1 1M14 10a4.5 4.5 0 0 0-6.4 0l-3.2 3.2a4.5 4.5 0 0 0 6.4 6.4l1-1" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg><span>Copy link</span>';
        copy.setAttribute('aria-label', 'Copy a link to ' + it.label);
        body.appendChild(copy);
        inner.appendChild(body);
        a.appendChild(inner);
        sec.appendChild(h);
        sec.appendChild(a);
        acc.appendChild(sec);
        it.sec = sec;
        it.btn = btn;
        it.region = inner;
      });
      into.appendChild(acc);
    };

    var frag = d.createDocumentFragment();
    groups.forEach(function (g, gi) {
      var panel = el('div', 'jsq-pol__panel');
      panel.id = 'JsqPanel-' + gi;
      g.panel = panel;
      fill(g, panel);
      frag.appendChild(panel);
    });
    if (shared.length) {
      var box = el('div', 'jsq-pol__shared');
      var sh = el('p', 'jsq-pol__shared-h');
      sh.setAttribute('data-jsq-pop', '');
      sh.appendChild(el('span', null, root.getAttribute('data-shared-heading') || 'For every order'));
      box.appendChild(sh);
      shared.forEach(function (g) { fill(g, box); });
      frag.appendChild(box);
    }
    prose.textContent = '';
    prose.appendChild(frag);
    prose.classList.add('is-ready');
  }

  /* ================= 2. accordion ================= */
  var expand = $('[data-jsq-expand]');
  var expandT = $('[data-jsq-expand-t]');
  var at = 0;
  var visibleItems = function () {
    var list = groups[at] ? groups[at].items.slice() : [];
    shared.forEach(function (g) { list = list.concat(g.items); });
    return list;
  };
  var syncExpand = function () {
    if (!expand) return;
    var list = visibleItems();
    expand.hidden = list.length < 2;
    var all = list.length && list.every(function (it) { return it.sec.classList.contains('is-open'); });
    expand.classList.toggle('is-all', !!all);
    if (expandT) expandT.textContent = all ? (root.getAttribute('data-collapse') || 'Collapse all') : (root.getAttribute('data-expand') || 'Expand all');
  };
  var setItem = function (it, open) {
    it.sec.classList.toggle('is-open', open);
    it.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    it.region.inert = !open;
  };
  items.forEach(function (it) {
    setItem(it, false);
    it.btn.addEventListener('click', function () {
      setItem(it, !it.sec.classList.contains('is-open'));
      syncExpand();
    });
  });
  groups.forEach(function (g) { if (g.items.length) setItem(g.items[0], true); });

  /* ================= 3. switch between groups ================= */
  var sw = $('[data-jsq-switch]');
  var tabs = [];
  var select = function (i, focus) {
    if (!groups[i]) return;
    groups.forEach(function (g, gi) {
      var on = gi === i;
      if (g.panel.hidden === on) {
        g.panel.hidden = !on;
        if (on && anim) {
          g.panel.classList.remove('is-entering');
          void g.panel.offsetWidth;
          g.panel.classList.add('is-entering');
        }
        if (on) $$('[data-jsq-pop]', g.panel).forEach(function (x) { x.classList.add('is-in'); });
      }
      if (tabs[gi]) {
        tabs[gi].setAttribute('aria-selected', on ? 'true' : 'false');
        tabs[gi].tabIndex = on ? 0 : -1;
      }
    });
    at = i;
    if (sw) sw.style.setProperty('--at', i);
    if (focus && tabs[i]) tabs[i].focus();
    syncExpand();
  };

  if (sw && groups.length > 1) {
    sw.style.setProperty('--tabs', groups.length);
    groups.forEach(function (g, gi) {
      var t = el('button', 'jsq-pol__tab', g.label);
      t.type = 'button';
      t.id = 'JsqTab-' + gi;
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-controls', g.panel.id);
      g.panel.setAttribute('role', 'tabpanel');
      g.panel.setAttribute('aria-labelledby', t.id);
      t.addEventListener('click', function () { select(gi); });
      t.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        select((at + dir + groups.length) % groups.length, true);
      });
      sw.appendChild(t);
      tabs.push(t);
    });
    sw.hidden = false;
  }
  if (groups.length) {
    groups.forEach(function (g, gi) { if (gi > 0) g.panel.hidden = true; });
    select(0);
  }
  if (expand) {
    expand.addEventListener('click', function () {
      var list = visibleItems();
      var open = !list.every(function (it) { return it.sec.classList.contains('is-open'); });
      list.forEach(function (it) { setItem(it, open); });
      syncExpand();
    });
  }

  /* ================= 4. reading time ================= */
  var read = $('[data-jsq-read]');
  if (read && prose) {
    var count = clean(prose.textContent).split(' ').length;
    var span = read.querySelector('span:last-child') || read;
    span.textContent = Math.max(1, Math.round(count / 200)) + ' min read';
    read.hidden = false;
  }

  /* ================= 5. hero title, word by word ================= */
  var title = $('[data-jsq-split]');
  if (title) {
    var nWord = 0;
    var wrap = function (text, into) {
      text.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { into.appendChild(d.createTextNode(' ')); return; }
        var o = el('span', 'jsq-w');
        o.style.setProperty('--w', nWord);
        nWord += 1;
        o.appendChild(el('span', null, part));
        into.appendChild(o);
      });
    };
    var nodes = Array.prototype.slice.call(title.childNodes);
    title.textContent = '';
    nodes.forEach(function (node) {
      if (node.nodeType === 3) { wrap(node.textContent, title); return; }
      var shell = node.cloneNode(false);
      wrap(node.textContent, shell);
      title.appendChild(shell);
    });
    title.classList.add('is-split');
    if (anim) setTimeout(function () { title.classList.add('is-in'); }, 40);
    else title.classList.add('is-in');
  }

  /* ================= 6. count-up in the cards ================= */
  var countUp = function (node) {
    if (reduce) return;
    var m = /^(\d+(?:\.\d+)?)(.*)$/.exec(node.textContent.trim());
    if (!m) return;
    var end = parseFloat(m[1]);
    var dp = (m[1].split('.')[1] || '').length;
    var rest = m[2];
    var start = Date.now() + 250;
    var dur = 1100;
    node.textContent = (0).toFixed(dp) + rest;
    var tick = function () {
      var t = Math.min(1, Math.max(0, (Date.now() - start) / dur));
      node.textContent = (end * (1 - Math.pow(1 - t, 3))).toFixed(dp) + rest;
      if (t < 1) setTimeout(tick, 32);
    };
    setTimeout(tick, 250);
  };

  /* ================= 7. reveals ================= */
  var pops = $$('[data-jsq-pop]');
  var shown = function (x) {
    x.classList.add('is-in');
    if (x.matches('.jsq-pol__card')) { var c = $('[data-jsq-count]', x); if (c) countUp(c); }
  };
  if (anim && pops.length) {
    var fold = w.innerHeight * 0.95;
    var later = [];
    pops.forEach(function (x) {
      var r = x.getBoundingClientRect();
      if ((r.top < fold && r.bottom > 0) || (r.width === 0 && r.height === 0)) shown(x);
      else later.push(x);
    });
    root.classList.add('jsq-pol--anim');
    var heard = false;
    var io = new IntersectionObserver(function (entries) {
      heard = true;
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        shown(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    later.forEach(function (x) { io.observe(x); });
    setTimeout(function () {
      if (!heard) { later.forEach(function (x) { x.classList.add('is-in'); }); io.disconnect(); }
    }, 3000);
  } else {
    pops.forEach(function (x) { x.classList.add('is-in'); });
  }

  /* ================= 8. scroll: progress, journey, ghost word ================= */
  var bar = $('.jsq-pol__progress');
  var hero = $('.jsq-pol__hero');
  var ghost = $('[data-jsq-ghost]');
  var journey = $('[data-jsq-journey]');
  var steps = journey ? $$('[data-jsq-step]', journey) : [];
  var stepsList = journey ? $('.jsq-pol__steps', journey) : null;
  var main = $('.jsq-pol__main');

  var onScroll = function () {
    var vh = w.innerHeight;
    if (hero) {
      var hr = hero.getBoundingClientRect();
      if (ghost && !reduce && hr.bottom > 0) ghost.style.setProperty('--gx', Math.round(Math.max(0, -hr.top) * 0.35));
      if (bar) bar.classList.toggle('is-on', hr.bottom < 60);
    }
    if (bar && main) {
      var mr = main.getBoundingClientRect();
      var total = mr.height - vh * 0.5;
      var p = Math.min(1, Math.max(0, (vh * 0.5 - mr.top) / Math.max(1, total)));
      bar.style.setProperty('--rp', p.toFixed(4));
    }
    if (stepsList && steps.length) {
      var sr = stepsList.getBoundingClientRect();
      var jp = reduce ? 1 : Math.min(1, Math.max(0, (vh * 0.72 - sr.top) / Math.max(1, sr.height * 0.9)));
      stepsList.style.setProperty('--jp', jp.toFixed(4));
      steps.forEach(function (s, i) {
        var need = steps.length > 1 ? i / (steps.length - 1) : 0;
        s.classList.toggle('is-on', jp > 0 && jp >= need - 0.001);
      });
    }
  };
  if (!design) {
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onScroll);
    onScroll();
  } else if (stepsList) {
    stepsList.style.setProperty('--jp', 1);
    steps.forEach(function (s) { s.classList.add('is-on'); });
  }

  /* ================= 9. copy a link ================= */
  var toast = $('[data-jsq-toast]');
  var tt;
  var say = function (msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-shown');
    clearTimeout(tt);
    tt = setTimeout(function () { toast.classList.remove('is-shown'); }, 1800);
  };
  if (prose) {
    prose.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.jsq-pol__copy');
      if (!b) return;
      var sec = b.closest('.jsq-pol__item');
      var url = w.location.href.split('#')[0] + '#' + sec.id;
      if (w.history.replaceState) w.history.replaceState(null, '', '#' + sec.id);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { say('Link copied'); }, function () { say('Link ready in the address bar'); });
      } else {
        say('Link ready in the address bar');
      }
    });
  }

  /* ================= 10. arriving with #section ================= */
  var openHash = function () {
    if (w.location.hash.length < 2) return;
    var id = decodeURIComponent(w.location.hash.slice(1));
    var it = items.filter(function (x) { return x.sec.id === id; })[0];
    if (!it) return;
    var gi = groups.indexOf(it.group);
    if (gi > -1 && gi !== at) select(gi);
    setItem(it, true);
    syncExpand();
    setTimeout(function () { it.sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 80);
  };
  openHash();
  w.addEventListener('hashchange', openHash);

  /* keep the current page's chip in view */
  var chip = $('.jsq-pol__chips [aria-current="page"]');
  var row = chip && chip.closest('ul');
  if (row && row.scrollWidth > row.clientWidth) {
    row.scrollLeft += chip.getBoundingClientRect().left - row.getBoundingClientRect().left - 20;
  }
})();
